import { useLocation, useNavigate } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import CommonBankLogo from "../../../_utils/CommonBankLogo";
import ListContainer from "../../../_utils/CommonListView/ListContainer";
import ListTextWithIcon from "../../../_utils/CommonListView/ListSubComponent/ListTextWithIcon";
import CommonToast from "../../../_utils/CommonToast";
import TickerAnimation from "../../../_utils/TickerAnimation";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import { standardAccountNumberFormat } from "../../../../utils/standardAccountNumberFormat";
import { useSelector } from "react-redux";

const BeneficiaryAccountListView = ({
  id,
  subType,
  data,
  typepop,
  handleButtonClick,
  associateAccount,
  beneAccountId,
  txnPayLoad,
  scheduleIntenralTxn,
  isLabelClicked,
  LabelAccounts,
  setlableInput,
  associateTxn,
  filterRef,
  type,
  onCardNavigate,
  setOpenBeneAssociate,
  setIsalertPopup,
  setFlowSelectedId,
  classifiedFlow,
  handleLabelSelect,
  onClosepop,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { services } = useSelector((state) => state.refreshToken);

  const getStatusColor = (status) => {
    switch (status) {
      case "pending":
        return "var(--pending)";
      case "approved":
        return "var(--awaiting)";
      case "rejected":
      case "blocked":
        return "var(--failed)";
      case "archived":
        return "var(--abandoned)";
      default:
        return "var(--awaiting)";
    }
  };

  const listdata = data || [];

  return (
    <>
      <div
        className={
          listdata?.length === GlobalConfiguration?.lengthCheckOne
            ? "p-padding-md w-width-full h-height-full"
            : "standard-list-view-alignment"
        }
      >
        {listdata &&
          listdata?.map((item) => {
            const redirectUrl = `/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/${item.id}`;
            return (
              <ListContainer
                hoverHeight={GlobalConfiguration.beneAccountListHoverHeight}
                filterRef={filterRef}
                key={item.id}
                isSelected={
                  Array.isArray(LabelAccounts) &&
                  LabelAccounts?.some((acc) => acc?.id === item.id)
                }
                isDisabled={
                  item.id === id ||
                  item.id === beneAccountId ||
                  (!(
                    associateAccount ||
                    (associateTxn === "associateTxn" &&
                      (item?.approval_status === "blocked" ||
                        item?.approval_status === "archived" ||
                        item?.approval_status === "rejected"))
                  ) &&
                    typepop === "popup" &&
                    (item?.approval_status === "blocked" ||
                      item?.approval_status === "archived" ||
                      item?.approval_status === "rejected"))
                }
                context={item}
                onClickHandler={(e) => {
                  if (classifiedFlow) {
                    navigate(
                      `/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/${item.id}`,
                      {
                        replace: true,
                      },
                    );
                    return;
                  }
                  if (
                    type === "activeInactive" ||
                    type === "confirm_create_account"
                  ) {
                    setIsalertPopup(true);
                    setFlowSelectedId(item?.id);
                    return;
                  }
                  if (associateAccount && subType === "reimbursement") return;
                  if (onCardNavigate) {
                    onCardNavigate(redirectUrl);
                    return;
                  }
                  if (
                    typepop === "popup" &&
                    scheduleIntenralTxn &&
                    (item?.approval_status === "blocked" ||
                      item?.approval_status === "archived" ||
                      item?.approval_status === "rejected" ||
                      (txnPayLoad?.ownerBankAccountNo === item?.bank_acc_no &&
                        txnPayLoad?.ownerBankIFSC === item?.ifsc_code &&
                        txnPayLoad?.ownerPan === item?.pan_no))
                  ) {
                    CommonToast({
                      text: "Destination account cannot be same as source account.",
                      icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                      variant: "var(--error)",
                      buttonNeeded: false,
                    });
                    return;
                  } else if (
                    typepop === "popup" &&
                    (item?.approval_status === "blocked" ||
                      item?.approval_status === "archived" ||
                      item?.approval_status === "rejected") &&
                    !associateAccount
                  ) {
                    if (isLabelClicked) {
                      handleLabelSelect?.(item);
                      setlableInput(false);
                    } else {
                      return;
                    }
                  } else if (typepop === "popup" && !associateAccount) {
                    if (isLabelClicked) {
                      handleLabelSelect?.(item);
                      setlableInput(false);
                    } else {
                      if (e && e.stopPropagation) {
                        e.stopPropagation();
                      }
                      if (type === "openLabelSearchPopup") {
                           navigate(
                      `/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/${item.id}`,
                     
                      );
                      onClosepop()
                      }
                     
                      handleButtonClick(item);
                    }
                  } else {
                    const redirectUrl = `/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/${item.id}`;
                    if (!isLabelClicked) {
                      if (type !== "viewOnlyCards") {
                        if (onCardNavigate) {
                          onCardNavigate(redirectUrl);
                          return;
                        } else {
                          navigate(redirectUrl, {
                            state: {
                              isViewAll:
                                location.pathname ===
                                "/beneficiary_account_dashboard/beneficiary_account_view_all",
                            },
                          });
                        }
                      }
                      if (setOpenBeneAssociate) setOpenBeneAssociate(false);
                      setlableInput(false);
                    } else {
                      handleLabelSelect?.(item);
                      setlableInput(false);
                    }
                  }
                }}
              >
                <list-body>
                  <div className="w-full flex justify-between pr-padding-sm gap-x-gap-sm py-padding-sm">
                    <div className="flex flex-col gap-y-gap-sm w-full">
                      <div className="w-full flex gap-x-gap-sm">
                        <div className="bg-text-primary py-padding-xs flex justify-center items-center px-padding-sm rounded-r-border-radius-md">
                          <CommonBankLogo
                            variant="small"
                            ifsc={item.ifsc_code}
                          />
                        </div>
                        <p className="text-text-primary text-font-xs flex-1 min-w-standard-account-min-width truncate flex font-normal">
                          <TickerAnimation
                            text={standardAccountNumberFormat(
                              item?.bank_acc_no,
                              true,
                            )}
                          />
                        </p>
                        <div className="border-l border-primary-bg"></div>
                        <div className="flex gap-x-gap-sm justify-end items-center">
                          <p
                            style={{
                              color: getStatusColor(item?.approval_status),
                            }}
                            className="text-font-xs font-semibol capitalize min-w-standard-approval-status-min-width text-right"
                          >
                            {(services?.includes("BAAccount") ||
                              services?.includes("Admin")) &&
                            item?.approval_status === "pending"
                              ? "Require approval"
                              : item?.approval_status}
                          </p>

                          <img
                            style={{
                              display: isLabelClicked ? "flex" : "none",
                            }}
                            className="w-icon-sm h-icon-sm flex-shrink-0 cursor-pointer"
                            src={
                              Array.isArray(LabelAccounts) &&
                              LabelAccounts?.some((acc) => acc?.id === item.id)
                                ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                                : ICONS?.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE
                            }
                            alt=""
                          />
                        </div>
                      </div>
                      <p className="text-font-xs pl-padding-sm text-text-primary flex-1 truncate font-normal">
                        <TickerAnimation text={item?.name} />
                      </p>
                    </div>
                  </div>
                </list-body>
                <list-hover>
                  <ListTextWithIcon
                    type={"text"}
                    text={item?.labels?.join(", ") || "No labels assigned "}
                    iconComponentArray={[{ icon: ICONS?.LABEL }]}
                  />
                </list-hover>
              </ListContainer>
            );
          })}
      </div>
    </>
  );
};

export default BeneficiaryAccountListView;
